/**
 * SignCell - one sign-off cell in the zone checklist grid: the wide CELL bar or
 * a single robot square, in its empty / done / N/A / optimistic states.
 */
import { GREEN, fullStamp, initialsOf, shortDate } from './svmModel';

// One sign-off cell. wide=true → the full-width CELL bar; else a robot square.
// narrow=true (phone): no robot header row exists, so each square carries its
// own robot label ("R1" grey when empty, "R1 · LC 7/13" when done, "R1 · N/A"),
// grows to a ≥42px touch target, and flexes inside a wrapping row.
export default function SignCell({ check, wide, dimmed, label, narrow, onClick }) {
  let bg = '#FAFAFA';
  let border = '#DDD';
  let color = '#C5C5C5';
  let text = wide ? 'CELL' : '';
  if (check) {
    if (check.status === 'na') {
      bg = '#FFF8E1';
      border = '#FFE082';
      color = '#8D6E00';
      text = 'N/A';
    } else {
      bg = '#E8F5E9';
      border = '#A5D6A7';
      color = GREEN;
      text = check.optimistic ? '✓' : `${initialsOf(check.checkedBy)} ${shortDate(check.checkedAt)}`;
    }
  }
  if (narrow && !wide) {
    if (!check) text = label || '';
    else if (check.status === 'na') text = `${label} · N/A`;
    else if (check.optimistic) text = `${label} ✓`;
    else text = `${label} · ${initialsOf(check.checkedBy)} ${shortDate(check.checkedAt)}`;
  }
  return (
    <button
      type="button"
      onClick={onClick}
      title={
        check
          ? `${check.checkedBy || 'Unknown'} · ${fullStamp(check.checkedAt)}${check.note ? ` - ${check.note}` : ''}`
          : wide
            ? 'Sign off for the whole cell'
            : `Sign off ${label}`
      }
      style={{
        height: narrow ? 42 : 26,
        minWidth: narrow && !wide ? 86 : 0,
        width: narrow && !wide ? 'auto' : '100%',
        flex: narrow && !wide ? '1 1 auto' : undefined,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: bg,
        border: `1px solid ${border}`,
        borderRadius: 6,
        fontFamily: "'Montserrat', sans-serif",
        fontSize: narrow ? 11 : wide ? 9.5 : 8.5,
        fontWeight: 800,
        color,
        cursor: 'pointer',
        padding: narrow ? '0 10px' : 0,
        letterSpacing: wide && !check ? 1.5 : 0,
        opacity: dimmed ? 0.25 : 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {text}
    </button>
  );
}
